import graphql__fd40e6f6c5aa530850a5 from "./__generated__/PageSectionSidebarUsersGroupRequestLinkBlock_pageSection.graphql.js";import { useCallback, useRef, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { useFormatMessage } from "../Intl/Context";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import Icon from "../Utils/Icon";
import Button from "../Buttons/Button";

import { sendUsersGroupRequest } from "./../../mutations/SendUsersGroupRequestMutation";
import { useAlert } from "../Alerts/withAlert";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";
import ConfirmationModal from "../Modals/ConfirmationModal";
import { isUnauthorized } from "../Utils/authorizations";

const PageSectionSidebarUsersGroupRequestLinkBlock = props => {
  const pageSection = useFragment(
    PageSectionSidebarUsersGroupRequestLinkBlock_pageSection,
    props.pageSection
  );
  const { addRequestTitle, removeRequestTitle, iconClass, usersGroup } = pageSection;
  const { id: usersGroupId, alreadyGroupMember, alreadyRequested } = usersGroup;
  const { sendJoinGroupRequest } = usersGroup.authorizations;

  const [isLoading, setIsLoading] = useState(false);
  const openConfirmModalRef = useRef(() => {});
  const closeConfirmModalRef = useRef(() => {});

  const { showAlert } = useAlert();

  const t = useFormatMessage();
  const successMessage = t(intlMessages.success);
  const pendingMessage = t(intlMessages.pending);
  const confirmTitle = t(intlMessages.confirmTitle);
  const confirmMessage = t(intlMessages.confirmMessage);

  const handleButtonClicked = useCallback(() => {
    openConfirmModalRef.current && openConfirmModalRef.current();
  }, []);

  var title = alreadyGroupMember ? removeRequestTitle : addRequestTitle;

  const iconClassName = classNames(["text-sign-sm", iconClass]);

  const handleRequestComplete = useCallback(
    ({ sendUsersGroupRequest: { success, notice } }) => {
      setIsLoading(false);

      if (success) {
        showAlert({ type: ALERT_TYPE_SUCCESS, message: successMessage });
        closeConfirmModalRef.current && closeConfirmModalRef.current();
      } else {
        showAlert({ type: ALERT_TYPE_ERROR, message: notice });
      }
    },
    [showAlert, successMessage]
  );

  const handleConfirmButtonClicked = useCallback(() => {
    sendUsersGroupRequest(usersGroupId, handleRequestComplete);
    setIsLoading(true);
  }, [handleRequestComplete, usersGroupId]);

  // Do not show this button if the user is not authorized to join the group. This avoids
  // server side errors if the button is shown in pages where the authentication is not
  // required, as only users can join users groups.
  if (isUnauthorized(sendJoinGroupRequest)) return null;

  return (
    <>
      <Button
        type="button"
        className="btn btn-primary btn-block-md box-shadow-lg btn-expand-height padding-sm"
        onClick={handleButtonClicked}
        disabled={alreadyRequested}
      >
        <div className="page-section-link-block-inner">
          <div className="with-icon text-btn-lg">
            <Icon className={iconClassName} />

            <div className="with-icon-text">{title}</div>
          </div>

          {alreadyRequested && (
            <div className="text-subtitle-section">{pendingMessage}</div>
          )}
        </div>
      </Button>

      <ConfirmationModal
        title={confirmTitle}
        message={confirmMessage}
        openRef={openConfirmModalRef}
        closeRef={closeConfirmModalRef}
        onConfirm={handleConfirmButtonClicked}
        closeOnConfirm={false}
        isLoading={isLoading}
      />
    </>
  );
};

// const mapStateToProps = state => ({ viewer: state.viewer });

const PageSectionSidebarUsersGroupRequestLinkBlock_pageSection = graphql__fd40e6f6c5aa530850a5;

export default PageSectionSidebarUsersGroupRequestLinkBlock;

const intlMessages = defineMessages({
  pending: {
    id: "report.pending",
    defaultMessage: "Une demande est déjà en cours"
  },
  success: {
    id: "report.success",
    defaultMessage: "Votre demande à bien été enregistrée"
  },
  confirmTitle: {
    id: "report.confirmTitle",
    defaultMessage: "Rejoindre le groupe"
  },
  confirmMessage: {
    id: "report.confirmMessage",
    defaultMessage: `
      Votre demande pour rejoindre le groupe va être envoyée aux administrateurs du 
      groupe. Êtes-vous sûr de bien vouloir envoyer votre demande ?
    `
  }
});
